<template>
  <div class="doctor_component">
    <DoctorInformation :doctor="doctor" :show-reviews="showDoctorReviews" />

    <div
      v-if="showCancelButton || showMapButton || showProfileButton || showScheduleButton"
      class="qualify_resize doctor_component__actions sm:border-b sm:border-b-transparent"
    >
      <div class="flex flex-wrap specialist_button_gap">
        <div class="view_profile_button w-full flex flex-col items-start gap-3">
          <div
            v-if="showCancelButton || showMapButton"
            class="doctor_component__action-row flex items-center gap-2"
          >
            <AppButton
              v-if="showCancelButton"
              class="cancel-appointment-action flex-1"
              variant="secondary"
              @click.prevent="emitCancel"
            >
              <span>{{ $t("Cancel appointment") }}</span>
              <svg
                class="cancel-appointment-action__icon"
                viewBox="0 0 24 24"
                aria-hidden="true"
                focusable="false"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
                <path
                  d="M12 7v6"
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-width="1.5"
                />
                <circle cx="12" cy="16" r="0.8" fill="currentColor" />
              </svg>
            </AppButton>

            <AppButton
              v-if="showMapButton"
              class="doctor-map-icon-btn"
              variant="secondary"
              :aria-label="$t('View on map')"
              :title="$t('View on map')"
              @click.prevent="viewMapModal"
            >
              <img src="@/assets/images/maps.svg" alt="" class="w-[1.8rem]" />
            </AppButton>

            <AppButton
              v-if="showMapProfileRow && profileRoute"
              :to="profileRoute"
              variant="brand"
              class="doctor-profile-btn"
            >
              {{ $t("View profile") }}
            </AppButton>
          </div>

          <AppButton
            v-if="showScheduleButton"
            class="w-full"
            variant="secondary"
            :block="true"
            @click.prevent="viewMapModal"
          >
            <span>{{ $t("View schedules") }}</span>
          </AppButton>

          <AppButton
            v-if="showProfileButton && profileRoute && !showMapProfileRow"
            :to="profileRoute"
            variant="brand"
            :block="true"
          >
            {{ $t("View profile") }}
          </AppButton>
        </div>
      </div>
    </div>

    <BookingTypeSelector
      v-if="bookingOptionButtons.length"
      class="doctor_component__booking-options pt-[1.4rem] pb-[0.4rem]"
      :options="normalizedBookingOptions"
      :selected-key="expandedBookingKey"
      :show-label="bookingOptionButtons.length > 1"
      @select="selectBookingOptionByKey"
    />

    <div
      v-if="showServiceTime"
      class="flex flex-col items-start gap-[1.6rem] self-stretch px-0 py-[1.6rem]"
    >
      <div v-if="showCalendar" class="flex items-center justify-start gap-4">
        <img class="w-[2.4rem]" src="@/assets/images/Calendar.svg" alt="" />
        <p class="text-black font-medium">{{ appointmentDateDisplay }}</p>
      </div>
      <div
        v-if="showDoctorAddressLine"
        class="flex items-center justify-start gap-4"
      >
        <img class="w-[2.4rem]" src="@/assets/images/map-white.svg" alt="" />
        <p class="text-black font-medium">{{ doctor.mainAddress }}</p>
      </div>
      <!--
      <div v-if="showPaymentMethod && priceDisplay" class="flex items-center justify-start gap-4">
        <img class="w-[2.4rem]" src="@/assets/images/credit_card.svg" alt="" />
        <p class="text-black font-medium">{{ priceDisplay }}</p>
      </div>
      -->
    </div>

    <div v-if="showPersonalizedService" class="pt-[1.6rem] pb-[12.4rem] px-0">
      <p class="text-black text-[1.2rem] font-medium">
        {{ $t("Personalized service.") }}
      </p>
      <Services :showTitle="false" :services="doctor.services" />
    </div>

    <div class="px-0 py-[2.9rem]" v-if="showAboutMe">
      <p
        class="text-black md:text-[1.2rem] font-medium pb-[0.8rem] sm:text-[1.2rem]"
      >
        {{ $t("About me") }}
      </p>
      <div
        class="overflow-hidden text-black text-ellipsis md:text-[1.2rem] font-medium leading-[1.33] sm:text-[1.2rem]"
      >
        <p v-for="(item, index) in doctor.aboutMe" :key="index">{{ item }}</p>
      </div>
      <a
        href="#"
        class="text-black md:text-[1.2rem] block font-medium underline pt-[0.8rem] sm:text-[1.2rem]"
        >{{ $t("Show more") }}</a
      >
    </div>

    <!--
    <div v-if="showFirstConsultation" class="flex items-center justify-between">
      <h4 class="text-black font-medium md:text-[14px] sm:text-[14px]">
        {{$t('First consultation')}}
      </h4>
      <p class="text-black font-bold md:text-[14px] sm:text-[14px]">{{ consultationFeeDisplay }}</p>
    </div>
    -->

    <div v-if="showReviewButton" class="text-center pt_16">
      <CustomButton
        class="h-[5.6rem] w-[28.9rem]"
        :label="$t('Rate specialist')"
        @click.prevent="emitReview"
      />
    </div>

    <div
      v-if="showCancelAppointmentButton"
      class="view_profile_button mt_32 flex items-start gap-4"
    >
      <CustomButton
        class="w-full h-[5.6rem]"
        :label="$t('Yes, cancel')"
        isCancel="true"
        @click.prevent="emitCancel"
      />
      <CustomButton
        class="w-full h-[5.6rem]"
        :label="$t('Return')"
        @click.prevent="emitCloseModal"
      />
    </div>

  </div>
</template>

<script>
import DoctorInformation from "@/components/doctor/doctorInformation.vue";
import CustomButton from "@/components/buttons/customButton.vue";
import Services from "@/components/doctor/services.vue";
import AppButton from "@/components/buttons/AppButton.vue";
import BookingTypeSelector from "@/components/booking/bookingTypeSelector.vue";
import { buildDoctorProfileRoute } from "@/helpers/doctorRouteHelper";
import { ATTENDANCE_MODE, allowsInPerson } from "@/constants/attendanceMode";
import bookingTypeFallback from "@/assets/images/logo-medkus.png";

export default {
  name: "DoctorComponent",
  components: {
    DoctorInformation,
    CustomButton,
    Services,
    AppButton,
    BookingTypeSelector,
  },
  emits: [
    "cancel-appointment",
    "review-appointment",
    "view-map",
    "close-modal",
    "select-booking-option",
  ],
  props: {
    doctor: {
      type: Object,
      required: false,
    },
    showServiceTime: {
      type: Boolean,
      default: false,
    },
    showCalendar: {
      type: Boolean,
      default: true,
    },
    showFirstConsultation: {
      type: Boolean,
      default: true,
    },
    showDoctorAddress: {
      type: Boolean,
      default: true,
    },
    showPaymentMethod: {
      type: Boolean,
      default: true,
    },
    showPersonalizedService: {
      type: Boolean,
      default: false,
    },
    showAboutMe: {
      type: Boolean,
      default: false,
    },
    showMapButton: {
      type: Boolean,
      default: false,
    },
    showScheduleButton: {
      type: Boolean,
      default: false,
    },
    showProfileButton: {
      type: Boolean,
      default: false,
    },
    showCancelButton: {
      type: Boolean,
      default: false,
    },
    showReviewButton: {
      type: Boolean,
      default: false,
    },
    showCancelAppointmentButton: {
      type: Boolean,
      default: false,
    },
    showDoctorReviews: {
      type: Boolean,
      default: true,
    },
    activeBookingKey: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      bookingOptionImageErrors: {},
    };
  },
  watch: {
    bookingOptionButtons() {
      this.bookingOptionImageErrors = {};
    },
  },
  computed: {
    showMapProfileRow() {
      return (
        this.showMapButton && this.showProfileButton && !this.showCancelButton
      );
    },
    profileRoute() {
      return buildDoctorProfileRoute(this.doctor);
    },
    consultationFeeDisplay() {
      const fee = this.doctor?.consultationFee;
      if (fee === null || fee === undefined) {
        return "--";
      }

      const value = typeof fee === "number" ? fee.toString() : String(fee);
      const trimmed = value.trim();
      return trimmed || "--";
    },
    priceDisplay() {
      const price = this.doctor?.priceDisplay;
      if (typeof price === "string") {
        return price.trim();
      }
      return "";
    },
    appointmentDateDisplay() {
      const baseDate = this.doctor?.appointmentDate
        ? String(this.doctor.appointmentDate)
        : "";
      if (!baseDate) {
        return "";
      }
      if (!this.appointmentModeLabel) {
        return baseDate;
      }
      return `${baseDate} (${this.appointmentModeLabel})`;
    },
    appointmentModeLabel() {
      const mode = this.doctor ? this.doctor.attendanceMode : undefined;
      if (mode === ATTENDANCE_MODE.ONLINE_ONLY) {
        return this.$t("Online");
      }
      if (mode === ATTENDANCE_MODE.BOTH) {
        return this.$t("Online or in-person");
      }
      if (mode === ATTENDANCE_MODE.IN_PERSON) {
        return this.$t("In-person");
      }
      return "";
    },
    showDoctorAddressLine() {
      if (!this.showDoctorAddress) {
        return false;
      }
      const mode = this.doctor ? this.doctor.attendanceMode : undefined;
      return allowsInPerson(mode);
    },
    bookingOptionButtons() {
      if (!this.doctor || !this.doctor.bookingOptions) {
        return [];
      }

      const unique = new Map();
      this.doctor.bookingOptions.forEach((option) => {
        const rawKey = option.key ?? option.bookingTypeId ?? option.label;
        const normalizedKey = String(rawKey);
        if (!unique.has(normalizedKey)) {
          unique.set(normalizedKey, {
            ...option,
            key: normalizedKey,
          });
        }
      });

      return Array.from(unique.values());
    },
    selectedBookingKeyNormalized() {
      return this.activeBookingKey !== null &&
        this.activeBookingKey !== undefined
        ? String(this.activeBookingKey)
        : null;
    },
    expandedBookingKey() {
      if (!this.bookingOptionButtons.length) {
        return null;
      }
      return (
        this.selectedBookingKeyNormalized || this.bookingOptionButtons[0].key
      );
    },
    normalizedBookingOptions() {
      // spread first so new option fields reach the selector without touching this map
      return this.bookingOptionButtons.map((option) => ({
        ...option,
        key: option.key,
        label: this.resolveBookingOptionLabel(option),
        price: this.resolveBookingOptionPrice(option),
        description: this.resolveBookingOptionDescription(option),
        // Only pass a real booking-type image, never the blurry logo fallback.
        image: this.isBookingOptionFallbackImage(option)
          ? ""
          : this.resolveBookingOptionImage(option),
      }));
    },
  },
  methods: {
    resolveBookingOptionLabel(option) {
      return option.bookingTypeName || option.label || this.$t("Service");
    },
    resolveBookingOptionDescription(option) {
      return option.bookingTypeDescription || "";
    },
    resolveBookingOptionPrice(option) {
      return option.price || "";
    },
    resolveBookingOptionImage(option) {
      if (this.bookingOptionImageErrors[option.key]) {
        return bookingTypeFallback;
      }
      return option.bookingTypeImage || bookingTypeFallback;
    },
    isBookingOptionFallbackImage(option) {
      return (
        !option.bookingTypeImage || this.bookingOptionImageErrors[option.key]
      );
    },
    selectBookingOptionByKey(key) {
      this.$emit("select-booking-option", String(key));
    },
    emitCancel() {
      this.$emit("cancel-appointment", this.doctor);
    },
    emitReview() {
      this.$emit("review-appointment", this.doctor);
    },
    viewMapModal() {
      this.$emit("view-map", this.doctor);
    },
    emitCloseModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.doctor_component {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* Actions now sit directly under the name, compact (not full-height pills) */
.doctor_component__actions {
  margin-top: 1.2rem;
}

.doctor_component__actions :deep(.app-button) {
  min-height: 3.4rem;
  padding: 0.5rem 1.2rem;
  font-size: 1.3rem;
  gap: 0.6rem;
  white-space: nowrap;
}

.doctor_component__actions :deep(.app-button img) {
  width: 1.8rem;
  height: 1.8rem;
}

/* Compact professional actions: profile pill + icon-only map button */
.doctor_component__actions :deep(.doctor-map-icon-btn) {
  width: 3.4rem;
  min-width: 3.4rem;
  padding: 0;
  flex-shrink: 0;
}

.doctor_component__actions :deep(.doctor-profile-btn) {
  padding: 0.5rem 1.8rem;
}

/* Compact the action buttons on small screens so they don't dominate the card
   or wrap to two lines. */
@media (max-width: 640px) {
  .doctor_component__actions :deep(.app-button) {
    padding: 0.5rem 1rem;
    font-size: 1.2rem;
  }

  .doctor_component__actions :deep(.app-button img),
  .doctor_component__actions :deep(.app-button svg) {
    width: 1.6rem;
    height: 1.6rem;
  }
}

.view_profile_button .cancel-appointment-action.app-button {
  border-color: #dc2626;
  color: #dc2626;
}

.view_profile_button
  .cancel-appointment-action.app-button:not(:disabled):not(
    .app-button--loading
  ):hover {
  background: rgba(220, 38, 38, 0.08);
  border-color: #b91c1c;
  color: #b91c1c;
}

.cancel-appointment-action__icon {
  width: 1.6rem;
  height: 1.6rem;
  stroke: currentColor;
}
</style>
